import Cookies from "js-cookie";

export function getCookie() {
  return Cookies.get("random_key");
}
